import type { PaymentOutcomesData } from "../../types.js";

export const OUTCOME_COLORS: Record<string, string> = {
  confirmed: "#31c48d",
  ack_timeout: "#64748b",
  cancelled_race: "#f472b6",
  cancelled_session: "#a855f7",
  cancelled_other: "#ec4899",
  submit_failed: "#ef4444",
  confirm_failed: "#dc2626",
  pending_timeout: "#f59e0b",
  refunded: "#6366f1",
};

export const OUTCOMES_CRITERIA = `Mobile checkout terminal outcomes from device_events (date + venue + device only; no Game filter).

Each slice prefers count(distinct checkout_id) for that event (and cancellation reason where split); falls back to row count when checkout_id is missing.

Slices: payment_confirmed (captured), payment_ack_timeout (table never acked — not charged), payment_cancelled (by reason), payment_submit_failed, payment_confirm_failed, payment_pending_timeout, payment_refunded.

Totals will not match Payment Attempted 1:1 — attempts count express_checkout_pressed rows; outcomes count terminal events (often one checkout_id per attempt).`;

export function outcomeRawEventsFilters(key: string) {
  switch (key) {
    case "confirmed":
      return { eventName: "payment_confirmed" };
    case "ack_timeout":
      return { eventName: "payment_ack_timeout" };
    case "cancelled_race":
      return {
        eventName: "payment_cancelled",
        propertiesContains: `"reason":"precondition_failed"`,
      };
    case "cancelled_session":
      return {
        eventName: "payment_cancelled",
        propertiesContains: `"reason":"session_ended"`,
      };
    case "cancelled_other":
      return { eventName: "payment_cancelled" };
    case "submit_failed":
      return { eventName: "payment_submit_failed" };
    case "confirm_failed":
      return { eventName: "payment_confirm_failed" };
    case "pending_timeout":
      return { eventName: "payment_pending_timeout" };
    case "refunded":
      return { eventName: "payment_refunded" };
    default:
      return { eventName: "all" };
  }
}

export function paymentOutcomePieSlices(data: PaymentOutcomesData) {
  return data.slices.map((s) => ({
    label: s.label,
    value: s.count,
    color: OUTCOME_COLORS[s.key] ?? "#5a6a8a",
    pieLabel: s.key === "confirmed" ? "OK" : undefined,
  }));
}
